import {
  SET_FORECASTED_REVENUE,
  SET_FORECASTED_DOE,
} from "./mutations";

const initialState = {
  forecastedRevenue: null,
  forecastedDOE: null,
};

const valuationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_FORECASTED_REVENUE:
      return { ...state, forecastedRevenue: payload };
    
    case SET_FORECASTED_DOE:
      return { ...state, forecastedDOE: payload };
    
    default:
      return state;
  }
};

export default valuationReducer;
